import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearBuffer } from '../../actions/buffer';

const initialState = null as GPSCoordinates | null;

const slice = createSlice({
  name: '$bufferDeliveryCoordinates',
  initialState,
  reducers: {
    setBufferDeliveryCoordinates(
      state,
      action: PayloadAction<GPSCoordinates | null>,
    ) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(clearBuffer, (_state, _action) => {
      return initialState;
    });
  },
});

export const { setBufferDeliveryCoordinates } = slice.actions;
export default slice.reducer;
